module.exports = __webpack_public_path__ + "img/scaldris_cold_front.1125333d.png";